import { render } from "./ForgotPasswordRequestInProgress.vue?vue&type=template&id=05475326"
import script from "./ForgotPasswordRequestInProgress.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordRequestInProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__